export default [{
    id: "27601",
    name: "Universitätsklinikum Schleswig-Holstein",
},{
    id: "27602",
    name: "Charité – Universitätsmedizin Berlin KöR", 
},
 {
    id: "27604",
    name: "Klinikum der LMU Muenchen",
},
{
    id: "27605",
    name: "Universitätsklinikum Tübingen",
},
/*{
     id: "27606",
     name: "University Hospital Hamburg- Eppendorf",
 },{
     id: "27607",
     name: "Center of Ophthalmology, University of Cologne",
 }, */
];